<header>
    <nav class="navbar navbar-light bg-light">
        <div class="align-self-center d-flex navbar-brand">
            <!-- <img src="https://fakeimg.pl/84x45/99cccc/" class="img-fluid" width="118"> -->
            <!-- <img src="https://fakeimg.pl/84x36/99cccc/" class="img-fluid" width="84" height="36"> -->
            <img src="assets/images/logo.png" class="img-fluid" width="84" height="36">

            <button class="nav-toggle" (click)="toggle()">
                <span *ngIf="!globals.menuOpened">
                    <i class="fas fa-bars"></i>
                </span>
                <span *ngIf="globals.menuOpened">
                    <i class="fas fa-angle-left mr-1"></i>
                    <i class="fas fa-bars"></i>
                </span>
            </button>
        </div>
        <div class="align-self-center d-flex" style="font-weight: bolder; font-size: 16px; font-family: monospace;">
            {{ "ACADYMIC_YEAR" | translate | titlecase }}: {{this.globals.currentUserInfo.yearid}} | {{ "SEMESTER" | translate | titlecase }}: 
            {{
                (globals.lang == 'ar')? semesterDes?.semesterNameAr : semesterDes?.semesterNameEn
            }}
        </div>
        <div class="account-header d-flex">
            <div class="dropdown">
                <button class="btn btn-link dropdown-toggle" type="button" id="dropdownLangButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-globe"></i> {{ currentLang }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownLangButton">
                    <a class="dropdown-item" (click)="changeLang('en')">{{ "EN" | translate | titlecase }}</a>
                    <a class="dropdown-item" (click)="changeLang('ar')">{{ "AR" | translate | titlecase }}</a>
                </div>
                </div>
            <div class="dropdown">
                <button class="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{globals.currentUserInfo.username}}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" (click)="logout()"><i class="fas fa-sign-out-alt pr-2"></i>{{ "LOGOUT" | translate | titlecase }}</a>
                    <!-- <a class="dropdown-item" routerLink="/change-password" ><i class="fas fa-key pr-2"></i>Change Password</a> -->
                    <a class="dropdown-item" routerLink="/change-password"*ngIf="globals.checkUserHasPermission('PROFILE - UPDATE')"><i class="fas fa-key pr-2"></i> {{ "CHANGE_PASSWORD" | translate | titlecase }}</a>
                    <a class="dropdown-item" routerLink="/user/profile"*ngIf="globals.checkUserHasPermission('PROFILE - UPDATE')"><i class="fas fa-user pr-2"></i> {{ "PROFILE" | translate | titlecase }}</a>
                </div>
            </div>
        </div>
    </nav>
</header>